module.exports = __webpack_public_path__ + "static/media/banner_forest_height_sat.a91ebec2.jpg";